module.exports = __webpack_public_path__ + "img/trophy.5642316.png";